import { render } from "./OneProjectLimits.vue?vue&type=template&id=1aae369a"
import script from "./OneProjectLimits.vue?vue&type=script&lang=js"
export * from "./OneProjectLimits.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__